define('drops/embed/embed',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            embedCode: ''
        }
    };

    function Embed(options) {
        Drop.call(this, $('<div class="boxToBorderSize embed-drop" />'), defaults, options);

        Style.renderStyles(this);
    };

    Drop.extend(Embed, Drop);

    Embed.typeName = 'Embed';

    Embed.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        if (this.data.embedCode)
            this.$element.html(this.data.embedCode);

        this.applyPosition();
    };
    
    return Embed;
});
